import { connect } from "react-redux";
import ImageUpload from "./component";
import { setFormData, nextStep, previousStep } from "../pickup-form.actions";

const mapStateToProps = (state) => ({
  images: state.donorWizard.formValues.images,
});

const mapDispatchToProps = {
  previousStep,
  nextStep,
  addImages: (images) => (dispatch, getState) => {
    const oldImages = getState().donorWizard.formValues.images;
    dispatch(setFormData({ images: [...oldImages, ...images] }));
  },
  removeImage: (idx) => (dispatch, getState) => {
    const oldImages = getState().donorWizard.formValues.images;
    dispatch(
      setFormData({ images: oldImages.filter((_, currIdx) => currIdx !== idx) })
    );
  },
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageUpload);
